import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import type { User } from 'altru-types';
import { UserInformation } from '@/types/user-data';

@Module({ namespaced: true })
export default class UsersModule extends VuexModule {
  user: User | null = null;
  userInformationCollectedValue: UserInformation | null = null;

  get currentUser(): User | null {
    return this.user;
  }

  @Mutation
  setUserInfo(value: User): void {
    this.user = value;
  }

  get userInformationCollected(): UserInformation | null {
    return this.userInformationCollectedValue;
  }

  @Mutation
  setUserInfoCollected(userInfo: UserInformation | null): void {
    this.userInformationCollectedValue = userInfo;
  }
}
